import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip, Typography } from 'antd'
import * as Icon from '@ant-design/icons'

import { useGlobalShortcut } from 'admin/lib/shortcuts'
import { Matchers } from 'admin/lib/Records'
import { AddInfractionModal } from './AddInfractionModal'

export function AddInfractionButton({ loaded }) {
  const [open, setOpen] = useState(false)

  useGlobalShortcut(
    Matchers.infraction.add,
    useCallback(() => {
      setOpen(true)
    }, [])
  )

  return (
    <Tooltip title="Previously, Add Infraction (Ctrl+I)">
      <Button
        type="primary"
        disabled={!loaded}
        onClick={() => {
          setOpen(true)
        }}
      >
        Add Alert
      </Button>

      <AddInfractionModal open={open} onClose={() => setOpen(false)} />
    </Tooltip>
  )
}

AddInfractionButton.propTypes = {
  loaded: PropTypes.bool.isRequired,
  infractionsByPath: PropTypes.object
}
